import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  OrderNotificationOptions,
  ResendOrderNotificationRequest,
  ResendOrderNotificationResult
} from 'washday-sdk';
import { getOrderNotificationOptions, resendOrderNotification } from '../../services/order.service';

export const useOrderNotificationOptions = (orderId: string, storeId: string, enabled: boolean) =>
  useQuery<OrderNotificationOptions>({
    queryKey: ['order-notification-options', orderId, storeId],
    enabled: enabled && Boolean(orderId && storeId),
    staleTime: 0,
    retry: false,
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const response = await getOrderNotificationOptions(orderId, storeId);
      if (!response?.data?.data) throw new Error('Missing order notification options.');
      return response.data.data;
    }
  });

export const useResendOrderNotification = () =>
  useMutation({
    // A retry is an explicit confirmation with the original idempotency key.
    retry: false,
    mutationFn: async ({
      orderId,
      ...data
    }: ResendOrderNotificationRequest & {
      orderId: string;
    }): Promise<ResendOrderNotificationResult> => {
      const response = await resendOrderNotification(orderId, data);
      if (!response?.data?.data) throw new Error('Missing order notification result.');
      return response.data.data;
    }
  });
